import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IOfferChallenge } from '@/shared/model/offer-challenge.model';

const baseApiUrl = 'api/offer-challenges';
const baseSearchApiUrl = 'api/_search/offer-challenges?query=';

export default class OfferChallengeService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IOfferChallenge> {
    return new Promise<IOfferChallenge>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IOfferChallenge): Promise<IOfferChallenge> {
    return new Promise<IOfferChallenge>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IOfferChallenge): Promise<IOfferChallenge> {
    return new Promise<IOfferChallenge>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
